'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testForCssGrid = testForCssGrid;
function testForCssGrid() {
  var body = document.body || document.documentElement;
  body.classList.add('util-JSEnabled');

  if ('grid' in body.style === false) {
    require('./css-grid');
    body.className += ' util-NoGrid';
  }
}